import { html as o, when as c } from "@microsoft/fast-element";
const l = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.32,3.27H6.29c-0.56,0-1.01,0.45-1.01,1.01v15.45c0,0.56,0.45,1.01,1.01,1.01h11.42
c0.56,0,1.01-0.45,1.01-1.01v-8.06 M10.32,3.27h0.34c4.45,0,8.06,3.61,8.06,8.06v0.34 M10.32,3.27c1.67,0,3.02,1.35,3.02,3.02v1.34
c0,0.56,0.45,1.01,1.01,1.01h1.34c1.67,0,3.02,1.35,3.02,3.02 M9.31,14.69l2.01,2.01l3.36-4.7"
      fill="currentColor"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.27,11.46c3.16,0,5.73-2.57,5.73-5.73S21.43,0,18.27,0c-3.17,0-5.73,2.57-5.73,5.73S15.1,11.46,18.27,11.46
        z M18.94,2.15c0-0.37-0.3-0.67-0.67-0.67c-0.37,0-0.67,0.3-0.67,0.67v3.58c0,0.37,0.3,0.67,0.67,0.67h2.87
        c0.37,0,0.67-0.3,0.67-0.67c0-0.37-0.3-0.67-0.67-0.67h-2.19V2.15z"
      fill="currentColor"
    />
  </svg>
`, r = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.32,3.27H6.29c-0.56,0-1.01,0.45-1.01,1.01v15.45c0,0.56,0.45,1.01,1.01,1.01h11.42
c0.56,0,1.01-0.45,1.01-1.01v-8.06 M10.32,3.27h0.34c4.45,0,8.06,3.61,8.06,8.06v0.34 M10.32,3.27c1.67,0,3.02,1.35,3.02,3.02v1.34
c0,0.56,0.45,1.01,1.01,1.01h1.34c1.67,0,3.02,1.35,3.02,3.02 M9.31,14.69l2.01,2.01l3.36-4.7"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.27,11.46c3.16,0,5.73-2.57,5.73-5.73S21.43,0,18.27,0c-3.17,0-5.73,2.57-5.73,5.73S15.1,11.46,18.27,11.46
        z M18.94,2.15c0-0.37-0.3-0.67-0.67-0.67c-0.37,0-0.67,0.3-0.67,0.67v3.58c0,0.37,0.3,0.67,0.67,0.67h2.87
        c0.37,0,0.67-0.3,0.67-0.67c0-0.37-0.3-0.67-0.67-0.67h-2.19V2.15z"
      fill="currentColor"
    />
  </svg>
`, t = o`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.6,2.72H5.24C4.78,2.72,4.4,3.1,4.4,3.57v12.87c0,0.47,0.38,0.84,0.84,0.84h9.52
    c0.47,0,0.84-0.38,0.84-0.84V9.72 M8.6,2.72h0.28c1.46,0,2.81,0.47,3.91,1.26c1.09,0.78,0.37,1.92,2.4,3.16
    c0.65,0.4,0.41,1.49,0.41,2.3v0.28 M8.6,2.72c1.39,0,2.52,1.13,2.52,2.52v1.12c0,0.47,0.38,0.84,0.84,0.84h1.12
    c1.39,0,2.52,1.13,2.52,2.52 M7.76,12.24l1.68,1.67l2.8-3.92"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.23,9.55c2.63,0,4.77-2.14,4.77-4.78S17.86,0,15.23,0c-2.64,0-4.77,2.14-4.77,4.78S12.58,9.55,15.23,9.55z
    M15.78,1.79c0-0.31-0.25-0.56-0.56-0.56s-0.56,0.25-0.56,0.56v2.98c0,0.31,0.25,0.56,0.56,0.56h2.39c0.31,0,0.56-0.25,0.56-0.56
    c0-0.31-0.25-0.56-0.56-0.56h-1.83L15.78,1.79L15.78,1.79z"
      fill="currentColor"
    />
  </svg>
`, n = o`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.88,2.18H4.19c-0.37,0-0.67,0.3-0.67,0.67v10.3c0,0.37,0.3,0.67,0.67,0.67h7.61c0.37,0,0.67-0.3,0.67-0.67
    V7.78 M6.88,2.18h0.23c1.09,0,2.1,0.32,2.94,0.88c0.86,0.56,0.11,1.43,1.97,2.32c0.66,0.31,0.46,1.4,0.46,2.18v0.23 M6.88,2.18
    c1.11,0,2.01,0.9,2.01,2.01v0.89c0,0.37,0.3,0.67,0.67,0.67h0.89c1.11,0,2.01,0.9,2.01,2.01 M6.21,9.79l1.34,1.34L9.79,8"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.18,7.64c2.11,0,3.82-1.71,3.82-3.82S14.29,0,12.18,0c-2.11,0-3.82,1.71-3.82,3.82S10.07,7.64,12.18,7.64z
    M12.63,1.43c0-0.25-0.2-0.45-0.45-0.45s-0.45,0.2-0.45,0.45v2.39c0,0.25,0.2,0.45,0.45,0.45h1.91c0.25,0,0.45-0.2,0.45-0.45
    s-0.2-0.45-0.45-0.45h-1.46L12.63,1.43L12.63,1.43z"
      fill="currentColor"
    />
  </svg>
`, s = o`
  ${c((e) => e._type === "outline", r)}
  ${c((e) => e._type === "solid", l)}
  ${c((e) => e._type === "mini", t)}
  ${c((e) => e._type === "micro", n)}
`;
export {
  s as documentCheckOnHold
};
